import { nextTick, watch } from 'vue';

// Capture against the old virtual layout, before Vue patches the new data.
// Restoring by conversation identity also works when a realtime update sorts
// an existing conversation above the viewport.
export function useConversationScrollAnchor(conversationIds, virtualListRef) {
  watch(conversationIds, async (currentIds, previousIds, onCleanup) => {
    const list = virtualListRef.value;
    if (!list || !previousIds.length || !currentIds.length) return;

    const scrollOffset = list.scrollOffset;
    if (scrollOffset <= 0) return;

    const firstIndex = list.findItemIndex(scrollOffset);
    const lastIndex = list.findItemIndex(scrollOffset + list.viewportSize);
    const currentIndexById = new Map(
      currentIds.map((id, index) => [id, index])
    );
    let anchorIndex = firstIndex;
    while (
      anchorIndex <= lastIndex &&
      !currentIndexById.has(previousIds[anchorIndex])
    ) {
      anchorIndex += 1;
    }
    // A replaced filter/list has no visible anchor to preserve.
    if (anchorIndex > lastIndex) return;

    const targetIndex = currentIndexById.get(previousIds[anchorIndex]);
    const unchangedPrefix = previousIds
      .slice(0, anchorIndex + 1)
      .every((id, index) => currentIds[index] === id);
    // Appending a page must not issue a scroll command during wheel/touch input.
    if (unchangedPrefix) return;

    const offset = scrollOffset - list.getItemOffset(anchorIndex);
    let cancelled = false;
    onCleanup(() => {
      cancelled = true;
    });
    await nextTick();
    if (cancelled || virtualListRef.value !== list) return;

    list.scrollToIndex(targetIndex, { align: 'start', offset });
  });
}
